/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1NotificationMobileAppSharedClassStudentsQueryResponse,
  GetApiV1NotificationMobileAppSharedClassStudentsQueryParams,
  GetApiV1NotificationMobileAppSharedClassStudents401,
  GetApiV1NotificationMobileAppSharedClassStudents500,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileAppSharedClassStudents.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1NotificationMobileAppSharedClassStudents } from "../../clients/notificationMobileAppController/getApiV1NotificationMobileAppSharedClassStudents.ts";

export const getApiV1NotificationMobileAppSharedClassStudentsQueryKey = (
  params?: GetApiV1NotificationMobileAppSharedClassStudentsQueryParams,
) =>
  [
    { url: "/api/v1/notification/mobile-app/shared/class-students" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1NotificationMobileAppSharedClassStudentsQueryKey =
  ReturnType<typeof getApiV1NotificationMobileAppSharedClassStudentsQueryKey>;

export function getApiV1NotificationMobileAppSharedClassStudentsQueryOptions(
  params?: GetApiV1NotificationMobileAppSharedClassStudentsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1NotificationMobileAppSharedClassStudentsQueryKey(params);
  return queryOptions<
    GetApiV1NotificationMobileAppSharedClassStudentsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1NotificationMobileAppSharedClassStudents401
      | GetApiV1NotificationMobileAppSharedClassStudents500
    >,
    GetApiV1NotificationMobileAppSharedClassStudentsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1NotificationMobileAppSharedClassStudents(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna turmas paginadas (20 por página) filtradas por nome ou código. Inclui a quantidade total de matriculados por turma. **(Requer Authorization para autenticação)**
 * @summary Busca turmas para seleção de notificação (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app/shared/class-students}
 */
export function useGetApiV1NotificationMobileAppSharedClassStudents<
  TData = GetApiV1NotificationMobileAppSharedClassStudentsQueryResponse,
  TQueryData = GetApiV1NotificationMobileAppSharedClassStudentsQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1NotificationMobileAppSharedClassStudentsQueryKey,
>(
  params?: GetApiV1NotificationMobileAppSharedClassStudentsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1NotificationMobileAppSharedClassStudentsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1NotificationMobileAppSharedClassStudents401
          | GetApiV1NotificationMobileAppSharedClassStudents500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1NotificationMobileAppSharedClassStudentsQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1NotificationMobileAppSharedClassStudentsQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1NotificationMobileAppSharedClassStudents401
      | GetApiV1NotificationMobileAppSharedClassStudents500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
